<!-- AI病历 -->
<template>
    <div class="content">
        <div class="inputBox">
            <div class="inputTitle">基本信息</div>
            <div class="leftBox">
                <div class="topBox">
                    <div class="inputItem topInput">
                        <div class="inputName">姓&nbsp;名：</div>
                        <input type="text" placeholder="请输入" v-model="name">
                    </div>
                    <div class="inputItem topInput">
                        <div class="inputName">性&nbsp;别：</div>
                        <input type="text" placeholder="请输入" v-model="gender">
                    </div>
                    <div class="inputItem topInput">
                        <div class="inputName">品&nbsp;种：</div>
                        <input type="text" placeholder="请输入" v-model="breed">
                    </div>
                    <div class="inputItem topInput">
                        <div class="inputName">年&nbsp;龄：</div>
                        <input type="text" placeholder="请输入" v-model="age">
                    </div>
                    <div class="inputItem topInput">
                        <div class="inputName">体&nbsp;重：</div>
                        <input type="text" placeholder="请输入" v-model="weight">
                    </div>
                </div>
                <div class="inputItem topInput" style="">
                    <div class="inputName">生活环境：</div>
                    <input type="text" placeholder="请输入" v-model="env">
                </div>
                <div class="inputItem topInput">
                    <div class="inputName">饮&nbsp;食：</div>
                    <input type="text" placeholder="请输入" v-model="diet">
                </div>
            </div>
        </div>

        <div class="inputBox">
            <div class="inputTitle">病&nbsp;史</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <div class="inputName">主&nbsp;诉：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="main_symptom"></textarea>
                </div>
                <div class="textInput">
                    <div class="inputName">免疫和驱虫情况：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="immun_worm"></textarea>
                </div>
                <!-- <div class="textInput">
                    <div class="inputName">既往史：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="med_history"></textarea>
                </div>
                <div class="textInput">
                    <div class="inputName">用药史：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="drug_history"></textarea>
                </div> -->
            </div>
        </div>

        <div class="inputBox">
            <div class="inputTitle">体格检查</div>
            <div class="inputItemBox">
                <div class="inputItem">
                    <div class="inputName">精神状态：</div>
                    <input type="text" placeholder="请输入" v-model="mental_state">
                </div>
                <div class="inputItem">
                    <div class="inputName">体格评分：</div>
                    <input type="text" placeholder="请输入" v-model="bcs">
                </div>
                <div class="inputItem">
                    <div class="inputName">体&nbsp;温：</div>
                    <input type="text" placeholder="请输入" v-model="temperature">
                </div>
                <div class="inputItem">
                    <div class="inputName">心&nbsp;脏：</div>
                    <input type="text" placeholder="请输入" v-model="vital_signs">
                </div>
                <!-- <div class="inputItem">
                    <div class="inputName">脉&nbsp;搏：</div>
                    <input type="text" placeholder="请输入" v-model="pulse">
                </div> -->
                <div class="inputItem">
                    <div class="inputName">呼&nbsp;吸：</div>
                    <input type="text" placeholder="请输入" v-model="respiratory">
                </div>
                <div class="inputItem">
                    <div class="inputName">黏膜颜色/CRT：</div>
                    <input type="text" placeholder="请输入" v-model="muc_color">
                </div>
                <!-- <div class="inputItem">
                    <div class="inputName">皮肤弹性：</div>
                    <input type="text" placeholder="请输入" v-model="skin_elastic">
                </div> -->
                <div class="inputItem">
                    <div class="inputName">水合状态：</div>
                    <input type="text" placeholder="请输入" v-model="hydration">
                </div>
                <div class="inputItem">
                    <div class="inputName">腹部触诊：</div>
                    <input type="text" placeholder="请输入" v-model="abdomen">
                </div>
                <!-- <div class="inputItem">
                    <div class="inputName">外周淋巴结：</div>
                    <input type="text" placeholder="请输入" v-model="lymph_nodes">
                </div>
                <div class="inputItem">
                    <div class="inputName">运动耐受度：</div>
                    <input type="text" placeholder="请输入" v-model="exercise">
                </div> -->
                <div class="textInput">
                    <div class="inputName">其他异常发现：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="体格检查中发现的异常表现" v-model="gait"></textarea>
                </div>
            </div>
        </div>

        
        <div class="inputBox">
            <div class="inputTitle">辅助检查</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <div class="inputName">实验室检查：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="lab_results"></textarea>
                </div>
                <div class="textInput">
                    <div class="inputName">影像学检查：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="imaging"></textarea>
                </div>
                <div class="textInput">
                    <div class="inputName">其他检查：</div>
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="special_tests"></textarea>
                </div>
                <!-- <div class="imgList">
                    <div class="imgItem" v-for="(item, index) in upImgList" :key="index">
                        <img class="imgU" :src="imgSrc + item.file_url" alt="" @click="openBigImg(item)">
                        <img class="closeIcon" src="../assets/images/closeBtn.png" alt="" @click="deleteImg(item,index)">
                    </div>
                    <div class="addImg" v-show="upImgList.length < 8">
                        选择图片
                        <input class="updataInput" type="file" @change="uploadImage"/>
                    </div>
                </div>
                <div class="toast">
                    (最多上传8张,图片大小不超过1MB)
                </div> -->
            </div>
        </div>

        <div class="inputBox">
            <div class="inputTitle">问题列表</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="questions_list"></textarea>
                </div>
            </div >
        </div>

        <div class="inputBox">
            <div class="inputTitle">鉴别诊断列表</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="differential_diagnosis_list"></textarea>
                </div>
            </div >
        </div>

        <div class="inputBox">
            <div class="inputTitle">诊&nbsp;断</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="diagnosis_list"></textarea>
                </div>
            </div >
        </div>


        <div class="inputBox">
            <div class="inputTitle">治疗计划</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="treatment_plan"></textarea>
                </div>
            </div>
        </div>

        <!-- <div class="inputBox">
            <div class="inputTitle">病程记录</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="progress_note"></textarea>
                </div>
            </div>
        </div> -->
        
        <div class="inputBox">
            <div class="inputTitle">随&nbsp;访</div>
            <div class="inputItemBox">
                <div class="textInput">
                    <textarea class="textarea" @input="adjustHeight"  placeholder="请输入" v-model="follow_up"></textarea>
                </div>
            </div>
        </div>
        <div class="BtnBox" v-if="conversationId == ''">
            <img class="btnItem" @click="updateCaseDiagnosis()" src="../assets/images/AICaseHistoryBtn1.png" alt="">
            <img class="btnItem" @click="callbackQuiz()" src="../assets/images/AICaseHistoryBtn2.png" alt="">
        </div>
        
        <div class="bigImg" v-show="bigImgShow" @click="bigImgShow = false">
            <img class="imgUrl" :src="bigImgUrl" alt="">
        </div>
    </div>
</template>

<script>
import axios from "axios"; 
import Cookies from 'js-cookie'
import hex_md5 from "../assets/js/md5"
import { Base64 } from 'js-base64'
export default {
    data() {
        return {
            imgSrc: "https://case.chongyike.com",
            // 记录ID
            session_id: "",
            // 会话id
            conversationId: "",
            // 病历数据
            name: "", // 姓名
            gender: "", // 性别
            species: "", // 物种
            breed: "", // 品种
            age: "", // 年龄
            env: "", // 生活环境
            diet: "", // 饮食
            main_symptom: "", // 主诉
            immun_worm: "", // 免疫和驱虫情况
            med_history: "", // 既往史
            drug_history: "", // 用药史
            abn_appear: "", // 其他异常表现
            mental_state: "", // 精神状态
            weight: "", // 体重
            bcs: "", // 体格评分
            temperature: "", // 体温
            vital_signs: "", // 心脏
            pulse: "", // 脉搏
            respiratory: "", // 呼吸
            muc_color: "", // 黏膜颜色
            skin_elastic: "", // 皮肤弹性
            hydration: "",// 水合状态
            abdomen: "", // 腹部触诊
            lymph_nodes: "",// 外周淋巴结
            exercise: "", // 运动耐受度
            gait: "",// 其他异常发现
            lab_results: "", // 实验室检查
            imaging: "", // 影像学检查
            special_tests: "",// 其他检查
            differential_diagnosis_list: "",
            questions_list: "", //问题列表
            diagnosis_list: "", //诊断
            treatment_plan: "", //治疗计划
            progress_note: "",//病程记录
            follow_up: "", //随访
            // 图片列表
            upImgList: [],
            // 全部字段
            allResall: {},
            // 大图开关
            bigImgShow: false,
            // 放大图片
            bigImgUrl: "",
        };
    },
    created() {
        if(this.$route.query.text){
            this.conversationId = JSON.parse(this.decrypt(this.$route.query.text)).conversationId
            this.getCaseDiagnosis()
        }
    },
    methods: {
        // 获取病历数据
        getCaseDiagnosis(){
            const that = this
            var data = {
                type: 'getCaseDiagnosis',
                conversationID: that.conversationId,
            }
            this.get("/ai/decisionMaking", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    Object.keys(result).forEach(function(key) {
                        if(key == 'images'){
                            var imgArr = JSON.parse(result[key])
                            for (let i = 0; i < imgArr.length; i++) {
                                imgArr[i].upOff = 1
                            }
                            that.upImgList = imgArr
                            console.log(that.upImgList)
                        }else {
                            that[key] = result[key]
                        }
                    });
                    that.allResall = result
                    setTimeout(() => {
                        this.alljustHetght()
                    }, 100);
                }
            })
        },
        // 输入框自动高度
        alljustHetght(){
            const that = this
            var allE = document.getElementsByClassName("textarea")
            for (let i = 0; i < allE.length; i++) {
                const element = allE[i];
                element.style.height = `${element.scrollHeight}px`;
            }
        },
        adjustHeight(event) {
            const textarea = event.target;
            textarea.style.height = 'auto'; // 重置高度，以便计算实际内容的高度
            textarea.style.height = `${textarea.scrollHeight}px`; // 设置高度为内容实际高度
        },
        // 更新病历
        updateCaseDiagnosis(){
            var that = this
            var data = {}
            var allResall = that.allResall
            Object.keys(allResall).forEach(function(key) {
                if(allResall[key] && key !== "mader_time" && key !== "update_time" && key !== "data_state"){
                    data[key] = that[key]
                }
            });
            if(that.upImgList.length > 0){
                data.images = JSON.stringify(that.upImgList)
            }
            var text = Base64.encode(that.encrypt(JSON.stringify(data), 'huiyichongyikeyi'))
            const formData = new FormData();
            console.log(data)
            formData.append('text', text);
            var url = "http://appinterface.chongyike.com/ai/decisionMaking?type=updateCaseDiagnosis" + that.getConfigText()
                // url = "http://192.168.18.121:83/ai/decisionMaking?type=updateCaseDiagnosis" + that.getConfigText()
            axios.post(url, formData, {
                headers: {
                    'Authorization': Cookies.get('token')!='undefined'? 'Bearer ' + Cookies.get('token'):''
                }
            }).then(response => {
                // 处理响应
                if(response.data.code == "success"){
                    var result = response.data.result
                    this.$message({
                        showClose: true,
                        message: "保存成功",
                        type: 'success',
                        duration: 2000
                    });
                }else if(response.data.code == "error"){
                    this.$message({
                        showClose: true,
                        message: response.data.message,
                        type: 'error',
                        duration: 2000
                    });
                }else {
                    this.$message({
                        showClose: true,
                        message: response.data.message,
                        type: 'error',
                        duration: 2000
                    });
                }
            })
            .catch(error => {
                // 处理错误
                console.error(error);
            });
        },
        // AI会诊
        callbackQuiz(){
            const that = this
            var data = {
                question: that.iptText()
            }
            sessionStorage.setItem("AiCaseQuestion",JSON.stringify(data))
            that.$router.push({
                path: '/webAICase',
            })
        },
        // 上传图片
        uploadImage(event) {
            const that = this
            const file = event.target.files[0];
            const reader = new FileReader();
            reader.onload = () => {
                const formData = new FormData();
                formData.append('imgs', file);
                var url = "http://appinterface.chongyike.com/ai/decisionMaking?type=uploadeCaseImages" + that.getConfigText()
                    // url = "http://192.168.18.121:83/ai/decisionMaking?type=uploadeCaseImages" + that.getConfigText()
                axios.post(url, formData, {
                    headers: {
                        'Authorization': Cookies.get('token')!='undefined'? 'Bearer ' + Cookies.get('token'):''
                    },
                    data: formData
                }).then(response => {
                    // 处理响应
                    if(response.data.code == "success"){
                        var result = response.data.result
                        for (let i = 0; i < result.length; i++) {
                            result[i].upOff = 0
                            that.upImgList.push(result[i])
                        }
                        console.log(result)
                    }else if(response.data.code == "error"){
                        this.$message({
                            showClose: true,
                            message: response.data.message,
                            type: 'error',
                            duration: 2000
                        });
                    }else {
                        this.$message({
                            showClose: true,
                            message: response.data.message,
                            type: 'error',
                            duration: 2000
                        });
                    }
                })
                .catch(error => {
                    // 处理错误
                    console.error(error);
                });
            };
            reader.readAsDataURL(file);
        },
        // 删除图片
        deleteImg(item, index){
            const that = this
            let data = {
                type: 'deleteCaseImages',
                record_id: item.record_id
            }
            this.get("/ai/decisionMaking", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.upImgList.splice(index, 1)
					that.$message({
						showClose: true,
						message: "删除成功",
						type: 'success',
                        duration: 1500
					});
                } else {
                    console.log(res.data.message)
                }
            })
        },
        // 查看大图
        openBigImg(item){
            const that = this
            that.bigImgUrl = item.url
            that.bigImgShow = true
        },
        // 返回提问
        iptText() {
            const that = this
            return [
                that.name && `姓名:${that.name},\n`,
                that.gender && `性别:${that.gender},\n`,
                that.species && `物种:${that.species},\n`,
                that.breed && `品种:${that.breed},\n`,
                that.age && `年龄:${that.age},\n`,
                that.env && `生活环境:${that.env},\n`,
                that.diet && `饮食:${that.diet},\n`,
                that.main_symptom && `主诉:${that.main_symptom},\n`,
                that.immun_worm && `免疫和驱虫情况:${that.immun_worm},\n`,
                that.med_history && `既往史:${that.med_history},\n`,
                that.drug_history && `用药史:${that.drug_history},\n`,
                that.abn_appear && `其他异常表现:${that.abn_appear},\n`,
                that.mental_state && `精神状态:${that.mental_state},\n`,
                that.weight && `体重:${that.weight},\n`,
                that.bcs && `体格评分:${that.bcs},\n`,
                that.temperature && `体温:${that.temperature},\n`,
                that.vital_signs && `心脏:${that.vital_signs},\n`,
                that.respiratory && `呼吸:${that.respiratory},\n`,
                that.muc_color && `黏膜颜色:${that.muc_color},\n`,
                that.hydration && `水合状态:${that.hydration},\n`,
                that.abdomen && `腹部触诊:${that.abdomen},\n`,
                that.gait && `其他异常发现:${that.gait},\n`,
                that.lab_results && `实验室检查:${that.lab_results},\n`,
                that.imaging && `影像学检查:${that.imaging},\n`,
                that.special_tests && `其他检查:${that.special_tests},\n`,
            ]
            .filter(Boolean) // 过滤掉值为 false 的项（如 undefined、null 或空字符串）
            .join(''); // 拼接成最终字符串
        },
    }
}
</script>

<style lang="scss" scoped>
    .content {
        .inputBox {
            position: relative;
            margin: 30px 60px;
            box-shadow: 0 0 10px 2px #eee;
            .inputTitle {
                color: #fff;
                padding: 10px 30px;
                font-size: 20px;
                font-weight: 600;
                box-sizing: border-box;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                background-color: #6c9bf6;
            }
            .leftBox {
                padding: 10px 30px;
                .topBox {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    padding-right: 100px;
                    .inputItem {
                        display: flex;
                        align-items: center;
                    }
                    .topInput {
                        margin-right: 30px;
                        input {
                            width:300px;
                        }
                    }
                }
            }

            .petImg {
                position: absolute;
                right: 50px;
                bottom: 30px;
                width: 100px;
                height: 100px;
            }
            .inputItemBox {
                padding: 20px 30px;
            }
            .inputItem {
                display: flex;
                align-items: center;
                padding: 2px 0;
            }
            .textInput {
                padding: 5px 0;
                .inputName {
                    margin-bottom: 10px;
                }
            }
            .inputName {
                font-size: 20px;
                font-weight: 600;
            }
            input {
                width: 600px;
                height: 30px;
                font-size: 18px;
                border: none;
                outline: none;
                border-bottom: 1px solid #eee;
            }
            .textarea {
                overflow: hidden;
                width: 100%;
                min-height: 100px;
                padding: 10px;
                resize: none;
                font-size: 18px;
                box-sizing: border-box;
                border-radius: 10px;
                border: 1px solid #ccc;
                background-color: #f4f4f4;
                outline: none;
            }

        }
        .BtnBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 20px 300px;
            .btnItem {
                width: 200px;
            }
        }
        
        .imgList {
            display: flex;
            flex-wrap: wrap;
            .imgItem {
                position: relative;
                width: 200px;
                height: 200px;
                margin-right: 20px;
                border: 1px solid #ccc;
                .imgU {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    cursor: pointer;
                }
                .closeIcon {
                    position: absolute;
                    right: -10px;
                    top: -10px;
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                    background-color: #fff;
                    border-radius: 50%;
                }
            }
            .addImg {
                position: relative;
                width: 200px;
                height: 200px;
                display: flex;
                justify-content: center;
                align-items: center;
                border: 1px dashed #ccc;
                background-color: #fff;
                .updataInput {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 200px;
                    height: 200px;
                    opacity: 0;
                    cursor: pointer;
                }
            }
        }
    }
    
.bigImg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
    .imgUrl {
        height: 100vh;
    }
}
    
    input, textarea {
        font-family: PingFangSC-Regular, PingFang SC, AlibabaPuHuiTi-Regular, Helvetica, AlibabaPuHuiTi;
    }
</style>